import gql from 'graphql-tag';
import { clients } from '../../../util/clients';
import { fieldsToGqlString, mergeByIdNewAtTop } from '../../../util/shared/vue-global';

const { backend } = clients.direct;

const pickFields = {
  _id: '',
  taxYear: '',
  taxId: '',
  name1: '',
  name2: '',
  taxType: '',
  ownerId: '',
  baseId: '',
  originalTax: '',
  totalTax: '',
  penalty: '',
  totalPaid: '',
  totalFee: '',
  totalDue: '',
  schoolDistrict: '',
  adjustments: '',
  amountPaidUnderProtest: '',
  amountPaidNoProtest: '',
  penaltyStartDate: '',
  feesAndPen: '',
  taxInquiryTransaction: '',
  mtgCode: '',
  statusCode: '',
  totalPayment: '',
};

const pickFieldsForGet = {
  statusCodes: '',
  feeList: {
    _id: '',
    taxYear: '',
    taxId: '',
    taxInquiryTransaction: '',
    feeAmount: '',
    feeNumber: '',
    effectiveDate: '',
  },
  ...pickFields,
};
const adjFields = {
  _id: '',
  taxYear: '',
  taxId: '',
  schoolDistrict: '',
  adjDate: '',
  certDate: '',
  adjOrUpd: '',
  type: '',
  certNumber: '',
  landVal: '',
  improvementVal: '',
  mobileVal: '',
  penaltyVal: '',
  totalExemptions: '',
  comments: '',
  taxAmt: '',
  posted: '',
};

const taxProtestFields = {
  _id: '',
  taxYear: '',
  taxId: '',
  ownerName: '',
  taxDue: '',
  amountPaid: '',
  amountStillDue: '',
  amountPaidUnderProtest: '',
  amoundPaidNoProtest: '',
  totalPayment: '',
};

export const taxInquiryTabs = {
  namespaced: true,
  state: () => ({
    slectedComments: [],
    selectedAdjustments: [],
    slectedPickLists: [],
    selectedItems: [],
    emptyPickListFlag: false,
  }),
  mutations: {
    setComments(state, items) {
      state.slectedComments = items;
    },
    setAdjustments(state, items) {
      state.selectedAdjustments = items;
    },
    setPickList(state, items) {
      state.slectedPickLists = items;
    },
    setSelectedItems(state, items) {
      state.selectedItems = items;
    },
    setEmptyPickListFlag(state, val) {
      state.emptyPickListFlag = val;
    },
  },
  actions: {
    async loadTabsAdjustments({ commit, dispatch }, { criteria, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`
            query taxRollAdjustments($criteria: taxRollAdjustmentsCriteriaType) {
              taxRollAdjustments(criteria: $criteria) {
                ${fieldsToGqlString(adjFields)},
              }
            }
          `,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const taxData = results.data.taxRollAdjustments;
          commit('base/crud/setItems', [baseCrudKey, taxData], { root: true });
          return taxData;
        }
      } catch (e) {
        dispatch('logException', e, { root: true });
        clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting tax adjustments.', { root: true });
      }
      return null;
    },
    async loadPickLists({ commit, dispatch }, { criteria, baseCrudKey, postProcessTransaction }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query taxPickList($criteria: pickListCriteriaType) {
            taxPickList(criteria: $criteria) {
              ${fieldsToGqlString(pickFieldsForGet)},
              }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const taxPickList = postProcessTransaction
            ? await postProcessTransaction(results.data.taxPickList)
              || [] : results.data.taxPickList;
          commit('base/crud/setItems', [baseCrudKey, taxPickList], { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting Pick List.', { root: true });
      }
    },
    async pickListLoadAndBuildRecords({ commit, dispatch },
      { criteria, baseCrudKey, postProcessTransaction }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query taxPickListLoadAndBuildRecords($criteria: pickListCriteriaType) {
            taxPickListLoadAndBuildRecords(criteria: $criteria) {
              ${fieldsToGqlString(pickFieldsForGet)},
              }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          if (results.data.taxPickListLoadAndBuildRecords[0].statusCodes === 201) {
            dispatch('custumColrFlashMsg', { msg: 'No records found!' }, { root: true });
          } else {
            const taxPickListLoadAndBuildRecords = postProcessTransaction
              ? await postProcessTransaction(results.data.taxPickListLoadAndBuildRecords)
            || [] : results.data.taxPickListLoadAndBuildRecords;
            commit('base/crud/setItems', [baseCrudKey, taxPickListLoadAndBuildRecords], { root: true });
          }
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting Pick List.', { root: true });
      }
    },
    async upsertPickList({ dispatch, rootGetters, commit }, {
      item, fields, baseCrudKey,
    }) {
      let results;
      try {
        const gqlfields = fields || pickFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertPickList ($item:pickListInputType)  {
            upsertPickList(upsert: $item) {
                    ${(fieldsToGqlString(gqlfields))},
                  }
                }`,
          variables: {
            item,
          },
        });

        clients.handleGQLErrors(results, commit);
        const oldPickListData = rootGetters['base/crud/items'](baseCrudKey);
        const newPickListData = results.data.upsertPickList;
        const newList = mergeByIdNewAtTop(oldPickListData || [], newPickListData);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the Pick List', { root: true });
      }
    },
    async upsertBulkPickList({ dispatch }, { item }) {
      try {
        await dispatch('reAuth', null, { root: true });
        await backend.mutate({
          mutation: gql`mutation upsertBulkPickList($item:[pickListInputType]) {
            upsertBulkPickList(upserts:$item) {
              ${(fieldsToGqlString(pickFields))}
            }
          }`,
          variables: {
            item,
          },
        });
      } catch (error) {
        dispatch('flashError', 'There was a problem while upserting the  pick list transaction!', { root: true });
      }
    },
    async UpsertPickListSingleNMultiplipleHybrid({ dispatch, commit }, {
      item,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation UpsertPickListSingleNMultiplipleHybrid ($item:pickListForMultipleInputType)  {
            UpsertPickListSingleNMultiplipleHybrid(upsert: $item) {
                    ${(fieldsToGqlString({ statusCodes: '' }))},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const { UpsertPickListSingleNMultiplipleHybrid } = results.data;
        if (UpsertPickListSingleNMultiplipleHybrid.statusCodes === 200) dispatch('flashSuccess', 'Added to Pick List', { root: true });
        else if (UpsertPickListSingleNMultiplipleHybrid.statusCodes === 201) dispatch('flashInfo', 'The selected record already exists in Pick List', { root: true });
        else dispatch('flashError', 'There was a problem in upserting the Pick List', { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the Pick List', { root: true });
      }
    },
    async UpsertBrowsePaidByPickListSingleNMultiplipleHybrid({ dispatch, commit }, {
      item,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation UpsertBrowsePaidByPickListSingleNMultiplipleHybrid ($item:browseByPaidByPickListForMultipleInputType)  {
            UpsertBrowsePaidByPickListSingleNMultiplipleHybrid(upsert: $item) {
                    ${(fieldsToGqlString({ statusCodes: '' }))},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const { UpsertBrowsePaidByPickListSingleNMultiplipleHybrid } = results.data;
        if (UpsertBrowsePaidByPickListSingleNMultiplipleHybrid.statusCodes === 200) dispatch('flashSuccess', 'Added to Pick List', { root: true });
        else if (UpsertBrowsePaidByPickListSingleNMultiplipleHybrid.statusCodes === 201) dispatch('flashInfo', 'The selected record already exists in Pick List', { root: true });
        else dispatch('flashError', 'There was a problem in upserting the Pick List', { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the Pick List', { root: true });
      }
    },
    async UpsertBrowsePaidByPickListSingleNMultiplipleUnpaidHybrid({ dispatch, commit }, {
      item,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation UpsertBrowsePaidByPickListSingleNMultiplipleUnpaidHybrid ($item:browseByPaidByPickListForMultipleInputType)  {
            UpsertBrowsePaidByPickListSingleNMultiplipleUnpaidHybrid(upsert: $item) {
                    ${(fieldsToGqlString({ statusCodes: '' }))},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const { UpsertBrowsePaidByPickListSingleNMultiplipleUnpaidHybrid } = results.data;
        if (UpsertBrowsePaidByPickListSingleNMultiplipleUnpaidHybrid.statusCodes === 200) dispatch('flashSuccess', 'Added to Pick List', { root: true });
        else if (UpsertBrowsePaidByPickListSingleNMultiplipleUnpaidHybrid.statusCodes === 201) dispatch('flashInfo', 'The selected record already exists in Pick List', { root: true });
        else dispatch('flashError', 'There was a problem in upserting the Pick List', { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the Pick List', { root: true });
      }
    },
    async deletePickList({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;

      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deletePickList ($id: ID!)  {
            deletePickList(id: $id) {
                  _id
                }
              }`,
          variables: {
            id: item._id,
          },
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data.deletePickList._id;
        const transData = rootGetters['base/crud/items'](baseCrudKey);
        const updatedData = transData.filter((d) => d._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while deleting the transaction!', { root: true });
      }
    },
    async deleteAllPickList({ commit, dispatch }, { baseCrudKey, item }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deleteEntirePickList ($item:pickListForMultipleInputType)  {
            deleteEntirePickList(upsert: $item) {
                    ${(fieldsToGqlString({ statusCodes: '' }))},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const { deleteEntirePickList } = results.data;
        if (deleteEntirePickList.statusCodes === 200) {
          dispatch('flashSuccess', 'Deleted the entire Pick List', { root: true });
          commit('base/crud/setItems', [baseCrudKey, []], { root: true });
        } else dispatch('flashError', 'There was a problem in deleting the Pick List', { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while deleting the Pick List!', { root: true });
      }
    },
    async loadProtestTaxPaymentsList({ commit, dispatch }, { criteria, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query taxProtestPayments($criteria: taxProtestPaymentsCriteriaType) {
            taxProtestPayments(criteria: $criteria) {
              ${fieldsToGqlString(taxProtestFields)},
              }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { taxProtestPayments } = results.data;
          commit('base/crud/setItems', [baseCrudKey, taxProtestPayments], { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting Protest Tax Payments.', { root: true });
      }
    },
    async upsertProtestTaxPaymentsList({ dispatch, rootGetters, commit }, {
      item, fields, baseCrudKey,
    }) {
      let results;
      try {
        const gqlfields = fields || taxProtestFields;
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertTaxProtestPayments ($item:taxProtestPaymentsInputType)  {
            upsertTaxProtestPayments(upsert: $item) {
                    ${(fieldsToGqlString(gqlfields))},
                  }
                }`,
          variables: {
            item,
          },
        });

        clients.handleGQLErrors(results, commit);
        const oldPickListData = rootGetters['base/crud/items'](baseCrudKey);
        const newPickListData = results.data.upsertTaxProtestPayments;
        const newList = mergeByIdNewAtTop(oldPickListData || [], newPickListData);
        commit('base/crud/setItems', [baseCrudKey, newList], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the Protest Tax Payments', { root: true });
      }
    },
    async deleteProtestTaxPaymentsList({ commit, rootGetters, dispatch }, { item, baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deleteTaxProtestPayments ($id: ID!)  {
            deleteTaxProtestPayments(id: $id) {
                  _id
                }
              }`,
          variables: {
            id: item._id,
          },
        });
        clients.handleGQLErrors(results, commit);
        const delId = results.data.deleteTaxProtestPayments._id;
        const transData = rootGetters['base/crud/items'](baseCrudKey);
        const updatedData = transData.filter((d) => d._id !== delId);
        commit('base/crud/setItems', [baseCrudKey, updatedData], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while deleting the transaction!', { root: true });
      }
    },
    async deleteAllProtestTaxPaymentsList({ commit, dispatch }, { baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deleteEntireTaxProtestPayments{
            deleteEntireTaxProtestPayments{
                  message
                }
              }`,
        });
        clients.handleGQLErrors(results, commit);
        commit('base/crud/setItems', [baseCrudKey, []], { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while deleting the transaction!', { root: true });
      }
    },
    async addCommentPickList({ commit, dispatch }, { item }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertPickListComment($item:taxCommentMutationInputType) {
            upsertPickListComment(upsert:$item) {
              result {
                ok,
              }
              insertedCount
              requestedCount
            }
          }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        if (results) {
          const { insertedCount = 0, requestedCount = 0 } = results.data.upsertPickListComment || {};
          if (requestedCount === 0) {
            dispatch('flashWarn', 'No pick list records found to add a comment to', { root: true });
          } else if (insertedCount < requestedCount) {
            dispatch('flashWarn', `Comment added to only ${insertedCount} of ${requestedCount} records`, { root: true });
          } else {
            dispatch('flashSuccess', `Comment added to ${insertedCount} record${insertedCount === 1 ? '' : 's'}`, { root: true });
          }
        }
      } catch (error) {
        dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while adding comment on pick list!', { root: true });
      }

      return {};
    },
    async changeAddressPickList({ commit, dispatch }, { item }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation pickListBulkAddressChange($item:taxTransactionInputType) {
            pickListBulkAddressChange(upsert:$item) {
              ${fieldsToGqlString({
    ids: '', comment: '', taxId: '', taxYear: '', category: '',
  })}
            }}`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        if (results) {
          dispatch('flashSuccess', 'Address Updated Succesfull', { root: true });
        }
        return results.data.pickListBulkAddressChange;
      } catch (error) {
        dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while updating address on pick list!', { root: true });
      }
      return {};
    },
    async pickListUpsertForEmail({ commit, dispatch }, { item }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation pickListUpsertForEmail($item:taxTransactionEmailAddressInputType) {
            pickListUpsertForEmail(upsert:$item) {
              ${fieldsToGqlString({
    statusCode: '',
  })}
            }}`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const { pickListUpsertForEmail } = results.data;
        if (pickListUpsertForEmail.statusCode === 200) {
          dispatch('flashSuccess', 'Phone/email applied to the pick list records', { root: true });
        } else {
          dispatch('flashError', 'There was a problem updating phone/email on the pick list!', { root: true });
        }
      } catch (error) {
        dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while updating email on pick list!', { root: true });
      }
      return {};
    },
    async pickListUpsertForComments({ commit, dispatch }, { item }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation pickListUpsertForComments($item:picklistInputType) {
            pickListUpsertForComments(upsert:$item) {
             result {
                ok,
              }
            }}`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
      } catch (error) {
        dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while updating address on pick list!', { root: true });
      }
      return {};
    },
    async pickListUpsertForAdjustments({ commit, dispatch }, { item }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation pickListUpsertForAdjustments($item:picklistAdjustmentsInputType) {
            pickListUpsertForAdjustments(upsert:$item) {
             result {
                ok,
              }
            }}`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
      } catch (error) {
        dispatch('logException', error, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while updating address on pick list!', { root: true });
      }
      return {};
    },
    async pickListProfiles({ commit, dispatch }, { baseCrudKey }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql`{
                pickListProfiles { profileList }
              }`,
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { pickListProfiles } = results.data;
          const res = pickListProfiles.profileList || [];
          commit('base/crud/setItems', [baseCrudKey, res], { root: true });
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting profile list.', { root: true });
      }
      return {};
    },
    async upsertPickListProfileNames({ dispatch, commit }, {
      item,
    }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation upsertPickListProfileNames ($item:pickListProfileInputType)  {
            upsertPickListProfileNames(upsert: $item) {
                    ${(fieldsToGqlString({ statusCodes: '' }))},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const { upsertPickListProfileNames } = results.data;
        if (upsertPickListProfileNames.statusCodes === 200) dispatch('flashSuccess', 'Added to Profile names', { root: true });
        else dispatch('flashError', 'There was a problem in upserting the Profile names', { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem in upserting the Profile names', { root: true });
      }
    },
    async deletePickListBasedOnProfileName({ commit, dispatch }, { baseCrudKey, item }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation deletePickListBasedOnProfileName ($item:pickListProfileInputType)  {
            deletePickListBasedOnProfileName(upsert: $item) {
                    ${(fieldsToGqlString({ statusCodes: '' }))},
                  }
                }`,
          variables: {
            item,
          },
        });
        clients.handleGQLErrors(results, commit);
        const { deletePickListBasedOnProfileName } = results.data;
        if (deletePickListBasedOnProfileName.statusCodes === 200) {
          dispatch('flashSuccess', 'Deleted the entire picklist based on profile name', { root: true });
          commit('base/crud/setItems', [baseCrudKey, []], { root: true });
        } else dispatch('flashError', 'There was a problem in deleting the Pick List', { root: true });
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem while deleting the Pick List!', { root: true });
      }
    },
    async updateMtgToPickList({ commit, dispatch }, { item }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.mutate({
          mutation: gql`mutation updateMtgToPickList ($item:pickListMtgCodeInputType)  {
            updateMtgToPickList(upsert: $item) {
                    status,
                    message,
                  }
                }`,
          variables: {
            item,
          },
        });
        if (results.data) {
          const { updateMtgToPickList } = results.data;
          if (updateMtgToPickList.status === true) {
            dispatch('flashSuccess', `${updateMtgToPickList.message}`, { root: true });
            return updateMtgToPickList;
          }
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem to update MTG code to pick list!', { root: true });
      }
      return results;
    },
    async taxPickListTotalRecords({ commit, dispatch }, { criteria }) {
      let results;
      try {
        await dispatch('reAuth', null, { root: true });
        results = await backend.query({
          query: gql` query taxPickListTotalRecords($criteria: pickListCriteriaType) {
            taxPickListTotalRecords(criteria: $criteria) {
              totalRecords,
              total,
              }
            }`,
          variables: { criteria },
          fetchPolicy: 'no-cache',
        });
        clients.handleGQLErrors(results, commit);
        if (results.data) {
          const { totalRecords, total } = results.data.taxPickListTotalRecords;
          return { totalRecords, total };
        }
      } catch (e) {
        dispatch('logException', e, { root: true }); clients.handleGQLErrors(results, commit);
        dispatch('flashError', 'There was a problem getting total records from Pick List.', { root: true });
      }
      return { totalRecords: 0, total: 0 };
    },
  },
};

export default taxInquiryTabs;
